export default "__VITE_ASSET__B38FKr9X__"